import * as StompJs from "stompjs-websocket";
import SockJS from "sockjs-client";
import store from "@/store/store";

export class StompClient {
  client: StompJs.Client;

  constructor() {
    this.client = StompJs.over(() => {
      return new SockJS(process.env.VUE_APP_WS_URL);
    });
    this.client.reconnect_delay = 5000;
    this.client.debug = this.onDebug;
  }

  connect(connectCallback: any) {
    if (process.env.NODE_ENV != "development") {
      const token = store.getters["AuthStore/getToken"];
      this.client.connect(
        { token: token },
        connectCallback,
        this.onError,
        this.onClose
      );
    }
  }

  onDebug(msg: string) {
    if (process.env.NODE_ENV != "production") {
      console.log(msg);
    }
  }

  onError(e: any) { }

  onClose(e: any) {
    console.log("close", e);
  }

  Send(destination: string, body: any) {
    if (this.client.connected) {
      this.client.send(destination, {}, JSON.stringify(body));
      return true;
    }
    return false;
  }

  isConnected() {
    return this.client.connected;
  }

  disconnect() {
    this.client.disconnect();
  }
}
